var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { belongsTo } from '@ember-data/model';
import { attr, hasMany } from '@ember-data/model';
import BaseActionProductModel from './base-action-product';
let ProductModelCommon = (_dec = attr(), _dec2 = attr(), _dec3 = attr(), _dec4 = attr(), _dec5 = attr(), _dec6 = belongsTo('description', {
  async: true
}), _dec7 = attr('string'), _dec8 = hasMany('action', {
  inverse: 'product',
  async: true
}), _dec9 = hasMany('product', {
  async: true
}), _class = class ProductModelCommon extends BaseActionProductModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "price", _descriptor, this);
    _initializerDefineProperty(this, "numberOfHtt", _descriptor2, this);
    _initializerDefineProperty(this, "isHttAccepted", _descriptor3, this);
    _initializerDefineProperty(this, "isNewProduct", _descriptor4, this);
    _initializerDefineProperty(this, "hasPublishedActions", _descriptor5, this);
    _initializerDefineProperty(this, "description", _descriptor6, this);
    _initializerDefineProperty(this, "type", _descriptor7, this);
    _initializerDefineProperty(this, "actions", _descriptor8, this);
    _initializerDefineProperty(this, "similarProducts", _descriptor9, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "price", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "numberOfHtt", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isHttAccepted", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isNewProduct", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasPublishedActions", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "actions", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "similarProducts", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ProductModelCommon as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.